'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _actions = require('../actions');

var _FolderListView = require('../components/Browser/Folders/FolderListView.jsx');

var _FolderListView2 = _interopRequireDefault(_FolderListView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return state.folders;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    initNewFolder: function initNewFolder() {
      dispatch((0, _actions.initNewFolder)());
    },
    openFolder: function openFolder(folder) {
      dispatch((0, _actions.openFolder)(folder, function (files) {
        dispatch((0, _actions.addFiles)(files));
      }));
    }
  };
};

var FolderList = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FolderListView2.default);

exports.default = FolderList;


//////////////////
// WEBPACK FOOTER
// ./client/containers/folderList.js
// module id = 76
// module chunks = 0